import React, { useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import { firestore } from '../firebase'

import AuthorPosts from '../components/Author/AuthorPosts'
import AuthorSavedRecipes from '../components/Author/AuthorProfile/AuthorSavedRecipes'
import Follow from '../components/Follow/Follow'
import StateContext from '../StateContext'
import AuthorFollowers from '../components/Author/AuthorProfile/AuthorFollowers'
import AuthorFollowing from '../components/Author/AuthorProfile/AuthorFollowing'

function ProfilePage() {

    const {id} = useParams()

    const appState = useContext(StateContext)

    const [author, setAuthor] = useState()
    const [activeItem, setActiveItem] = useState("1")

    const [isFollowing, setIsFollowing] = useState(false)
    const [postCount, setPostCount] = useState(0)

    const [followers, setFollowers] = useState([])
    const [following, setFollowing] = useState([])

    const [followersCount, setFollowersCount] = useState(0)
    const [followingCount, setFollowingCount] = useState(0)

    function toggle(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab)
        }
    }

    useEffect(() => {

        try {
            const authorRef = firestore.collection("authors")
            authorRef.where("user_id", "==", id).onSnapshot(({docs}) => {
                const author = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setAuthor(author[0])
                //console.log(author[0], "Author")
            })
            

        } catch (error) {
            
        }

    }, [id])


    return (
        <div className="container my-3">

            <div className="row">

                <div className="col-4">
                    <div className="row">
                        <div className="col-lg-6 mx-auto mt-3">
                            <img src={author ? author.profile_image : "https://camillahardilla.com/wp-content/uploads/2020/07/my-recipes-logo.png"} className="img-fluid rounded-circle" />
                        </div>
                    </div>
                </div>

                <div className="col-8">
                    <div className="col-lg-10">
                        <div className="row">
                            <div className="col-md-3">
                                <p className="mt-4">{author && author.name}</p>
                            </div>
                            <div className="col-md-9">
                                <div className="row">
                                    <div className="col-12 mt-3">                          
                                        <div className="row">
                                            <div className="col--lg-6">
                                                {appState.userId && appState.userId === id ? (
                                                    <Link 
                                                        to="/member/edit/my-profile" 
                                                        style={{padding: "9px"}} 
                                                        className="btn btn-sm btn-block btn-light btn-rounded profileBtn"
                                                    >
                                                        Rediger profil <i className="fas fa-cog"></i>
                                                    </Link>     
                                                )
                                                :
                                                    <Follow 
                                                        userId={id} 
                                                        userObj={author} 
                                                        isFollowing={isFollowing}
                                                        setIsFollowing={setIsFollowing}
                                                        followers={followers}
                                                        following={following}
                                                    />
                                                }
             
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>


                            <div className="column-large-insta col-12">
                                <div className="row">
                                    <div className="col-4 mt-2">
                                        {postCount} <span style={{color: "grey"}}>recipes</span>
                                    </div>
                                    <div className="col-4 text-center mt-2">
                                        <AuthorFollowers userId={id} setFollowersCount={setFollowersCount} followers={followers} setFollowers={setFollowers} />
                                    </div>

                                    <div className="col-4 mt-2">
                                        <div className="float-right">
                                            <AuthorFollowing userId={id} setFollowingCount={setFollowingCount} following={following} setFollowing={setFollowing} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 my-3 column-large-insta">
                                <h4 className="font-weight-bold">{author && author.name}</h4>
                                <p>Offisielle brukerkontoen til {author && author.name}</p>
                                <div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="column-small-insta col-12">

                    <h4 className="font-weight-bold mt-3">{author && author.name}</h4>
                    <p>Offisielle brukerkontoen til {author && author.name}</p>
                    <div>
                       
                    </div>
                                    
                    <div className="row">
                        <div className="hr" />
                        <div className="col-4 mt-2 text-center">
                            {postCount} <br/>
                            <span style={{color: "grey"}}>recipes</span>
                        </div>
                        <div className="col-4 text-center mt-2">
                            <AuthorFollowers userId={id} setFollowersCount={setFollowersCount} followers={followers} setFollowers={setFollowers} /> />
                        </div>

                        <div className="col-4 mt-2 text-center">
                            <div>
                                <AuthorFollowing userId={id} setFollowingCount={setFollowingCount} following={following} setFollowing={setFollowing} />
                            </div>
                        </div>
                        <hr/>
                    </div>                     
                </div>

            </div>

            <hr/>
            <div className="row">
                <div className="col-md-6 col-lg-4 mx-auto">
                    <div className="row" style={{marginTop: "-16px"}}>
                        <div className="col-6">
                            {activeItem === "1" && <div className="hr" />}
                            <button 
                                className="btn-block p-2" 
                                style={{border: "none", backgroundColor: "transparent"}} 
                                onClick={() => toggle("1")}
                            >
                                <i className="fas fa-th"></i> Innlegg
                            </button>
                        </div>
                                        
                        <div className="col-6">
                            {activeItem === "2" && <div className="hr" />}
                            <button 
                                className="btn-block p-2" 
                                style={{border: "none", backgroundColor: "transparent"}} 
                                onClick={() => toggle("2")}
                            >
                                <i className="far fa-bookmark"></i> Saved Recipes
                            </button>
                        </div>
                    </div>

                </div>
            </div>

            {activeItem === "1" && (
                <AuthorPosts setPostCount={setPostCount} userId={id} />
            )}
            {activeItem === "2" && (
                <AuthorSavedRecipes userId={id} />
            )}

        </div>
    )
}
export default ProfilePage